import { render, staticRenderFns } from "./MinhaIgreja.vue?vue&type=template&id=e17e771e&scoped=true"
import script from "./MinhaIgreja.vue?vue&type=script&lang=js"
export * from "./MinhaIgreja.vue?vue&type=script&lang=js"
import style0 from "./MinhaIgreja.vue?vue&type=style&index=0&id=e17e771e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e17e771e",
  null
  
)

export default component.exports